<template>
  <div class="official-success">
    <div class="empty-style">
      <div class="list-empty-box">
        <img src="@/assets/images/wechat_success_ico.png">
        <div class="text-bold">提交成功</div>
        <div class="text">马上为您处理</div>
        <div class="text">请留意我们工作人员的来电</div>
      </div>
      <div class="go-mini" v-if="queryParams.type === 'official'">
        <img src="@/assets/images/mini_code.png">
        <div class="font">
          扫码进入邦教练小程序<br>
          免费抢先体验！
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'officialSuccess',
  data() {
    return {
      queryParams: {}
    }
  },
  created() {

  },
  mounted() {
    this.queryParams = this.$route.query
  },
  methods: {
  }
}
</script>

<style lang="scss">
  .list-empty-box {
    padding-top: 128px;
    box-sizing: border-box;
    text-align: center;
    font-size: 13px;
    color: #8D90AE;
    line-height: 18px;
    .text-bold{
      font-size: 18px;
      color: #303239;
      font-weight: bold;
      margin-top: 18px;
      margin-bottom: 6px;
    }
    img{
      width:50px;
      height:50px;
    }
  }
  .go-mini{
    text-align: center;
    margin-top: 44px;
    img{
      width: 158px;
      height: 158px;
      border-radius: 12px;
    }
    .font{
      color: #303239;
      font-size: 14px;
      line-height: 22px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/official-success/index.vue